import { render, staticRenderFns } from "./selectObject.vue?vue&type=template&id=88d78ef8&scoped=true&"
import script from "./selectObject.vue?vue&type=script&lang=js&"
export * from "./selectObject.vue?vue&type=script&lang=js&"
import style0 from "./selectObject.vue?vue&type=style&index=0&id=88d78ef8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d78ef8",
  null
  
)

export default component.exports